import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Container, Typography } from '@mui/material';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import { useParams } from 'react-router-dom';
import { NFCDetailsWidget } from 'components/AccessDevice';
import Logs from 'components/Logs';
import { Details } from 'components/Customers';

export const NFCDetails = () => {
  const { id } = useParams();
  const title = i18n.t('nfc.details_title', { accessDeviceId: id });
  const { accessDevice } = useSelector((state) => state.accessDevice);

  return (
    <Layout title={title}>
      <Container sx={{ minWidth: '100%', margin: 0 }}>
        <Grid container>
          <Grid size={12}>
            <Typography variant="h1" gutterBottom>
              <Box fontWeight="fontWeightBold" fontSize={24} mb={1}>
                {title}
              </Box>
            </Typography>
          </Grid>
          <Grid container size={12} columnGap={4}>
            <Grid container size={{ sm: 12, md: 6, lg: 4 }}>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <NFCDetailsWidget id={id} view="nfc" />
                </Grid>
                <Grid size={12}>
                  <Details id={accessDevice?.user?.id} viewOnly />
                </Grid>
                <Can I="read" a="comment">
                  <Grid size={12}>
                    <Comments type="access_device" id={parseInt(id)} />
                  </Grid>
                </Can>
              </Grid>
            </Grid>
            <Grid container size={{ sm: 12, md: 6, lg: 4 }}>
              <Grid size={12}>
                <Logs
                  targetId={parseInt(id)}
                  targetType="AccessDevice"
                  title={i18n.t('nfc.logs')}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};
